import { Loader, Typography } from '@finam/web-ui-kit';
import { Divider } from '@finam/web-ui-kit/Tabs/Tabs.styles';
import React from 'react';
import { WebService } from '../Services/WebService';
import { TokenContext } from '../TokenContext';
import './InnerDocuments.scss';

interface IDoc {
    id: number,
    title: string,
    body: string,
    group: string
}

export default class InnerDocuments extends React.Component<{}, { items: IDoc[], isLoading: boolean, selectedGroup?: string, selectedDoc?: number }>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    constructor(props: any) {
        super(props);
        this.state = {
            items: [],
            isLoading: true
        }
    }

    componentDidMount(): void {
        this.setState({ isLoading: true });
        new WebService(this.context.token).GetInnerDocuments()
            .then(res =>
                this.setState({ items: res.result, isLoading: false }))
    }

    renderGroup(group: string): JSX.Element {
        const items = this.state.items.filter(d => d.group == group);
        return <div>
            <Typography variant='h4'><a onClick={() => this.setState({ selectedGroup: group })}>{group}</a></Typography>
            {this.state.selectedGroup == group && <div>
                {items.map(i => this.renderItem(i))}
            </div>}
        </div>
    }

    renderItem(item: IDoc): JSX.Element {
        return <div>
            <Typography variant='h5'><a onClick={() => {
                const index = this.state.selectedDoc == item.id ? 0 : item.id;
                this.setState({ selectedDoc: index });
            }}>{item.title}</a></Typography>
            {this.state.selectedDoc == item.id &&
                <div dangerouslySetInnerHTML={{ __html: item.body }} />
            }
            <Divider />
        </div>;
    }

    renderBody(): JSX.Element {
        function onlyUnique(value: any, index: number, self: any) {
            return self.indexOf(value) === index;
        }
        const groups = this.state.items.map(d => d.group).filter(onlyUnique);
        return <div className='innerDocuments'>{groups.map(g => this.renderGroup(g))}</div>
    }

    render(): React.ReactNode {
        return this.state.isLoading ? <Loader /> : this.renderBody();
    }
}